import React from 'react';
import { LinkedinIcon, TwitterIcon } from 'lucide-react';
export function TeamSection() {
  const teamMembers = [{
    name: 'Paweł Huryn',
    role: 'Author of the #1 AI & Product Newsletter | AI Agents & Architecture Expert',
    bio: "Paweł is the mind behind The Product Compass—a 15-year product veteran and former CPO who's spent the last decade building and scaling AI-powered products from 0 to impact.",
    additionalText: "He is driven by one question: How do you turn AI's potential into real user value? And more specifically, how do you equip product managers like you to lead that transformation?",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4QL5SXnyQr9Eszv526dwuH/Pawel.jpg',
    linkedin: 'https://pl.linkedin.com/in/pawel-huryn',
    twitter: 'https://twitter.com/PawelHuryn/'
  }, {
    name: 'Olia Herbelin',
    role: 'Community & Growth PM | The Product Compass',
    bio: 'Olia is a Strategic Product Director (14y+) and Complexity & Innovation Expert, excels in turning complexity into product growth. Currently leading initiatives at The Product Compass, she fast-tracks AI skill acquisition for PMs by facilitating immersive AI Agents Hackathons.',
    additionalText: 'One question guides her: Why learn AI alone when you can co create real agents from day one in an immersive experience?',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cQxnUkniK3CkiPvrinPXG9/OL.jpg',
    linkedin: 'https://www.linkedin.com/in/herbelin-olia/',
    twitter: ''
  }];
  const renderBioWithLink = (bio: string) => {
    const parts = bio.split('The Product Compass');
    if (parts.length === 1) return bio;
    return <>
        {parts[0]}
        <a href="https://www.productcompass.pm/" target="_blank" rel="noopener noreferrer" className="text-[#2f5f98] font-semibold hover:text-[#ff8a14] transition-colors underline decoration-[#2f5f98] hover:decoration-[#ff8a14]" data-id="element-423">
          The Product Compass
        </a>
        {parts[1]}
      </>;
  };
  return <div className="w-full bg-gradient-to-b from-[#f3f3f7] to-[#e6eef8] py-16 px-4" data-id="element-424">
      <div className="max-w-5xl mx-auto" data-id="element-425">
        <div className="text-center mb-12" data-id="element-426">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2f5f98] mb-4" data-id="element-427">
            Meet the Team
          </h2>
          <p className="text-[#606060] text-lg max-w-2xl mx-auto" data-id="element-428">
            The experts who designed this experience to maximize your learning,
            connections, and impact.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-429">
          {teamMembers.map((member, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow flex flex-col" data-id="element-430">
              <div className="p-8 flex flex-col flex-grow" data-id="element-431">
                <div className="flex flex-col items-center text-center mb-6" data-id="element-432">
                  <div className="w-32 h-32 rounded-full overflow-hidden mb-4 ring-4 ring-[#5590bc] ring-opacity-20" data-id="element-433">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-434" />
                  </div>
                  <h3 className="text-2xl font-bold text-[#2f5f98] mb-1" data-id="element-435">
                    {member.name}
                  </h3>
                  <p className="text-[#ff8a14] font-semibold mb-4" data-id="element-436">
                    {member.role}
                  </p>
                </div>

                <div className="text-[#4a5568] leading-relaxed mb-6 flex-grow" data-id="element-437">
                  <p className="mb-3" data-id="element-438">{renderBioWithLink(member.bio)}</p>
                  {member.additionalText && <p className="italic text-[#606060]" data-id="element-439">
                      {member.additionalText}
                    </p>}
                </div>

                <div className="flex justify-center space-x-4 mt-auto" data-id="element-440">
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#5590bc] bg-opacity-10 flex items-center justify-center hover:bg-opacity-20 transition-colors" aria-label={`${member.name} LinkedIn`} data-id="element-441">
                    <LinkedinIcon className="w-5 h-5 text-[#5590bc]" data-id="element-442" />
                  </a>
                  {member.twitter ? <a href={member.twitter} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#5590bc] bg-opacity-10 flex items-center justify-center hover:bg-opacity-20 transition-colors" aria-label={`${member.name} Twitter`} data-id="element-443">
                      <TwitterIcon className="w-5 h-5 text-[#5590bc]" data-id="element-444" />
                    </a> : <div className="w-10 h-10 rounded-full bg-transparent flex items-center justify-center opacity-0 pointer-events-none" data-id="element-445">
                      <TwitterIcon className="w-5 h-5 text-[#5590bc]" data-id="element-446" />
                    </div>}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}